import * as React from "react";
import { Slider as SliderPrimitive } from "@base-ui/react/slider";
import { cn } from "@/shared/utils/utils";
import { SliderProps } from "../extended/type";

const Slider = React.forwardRef<HTMLDivElement, SliderProps>(
  (
    {
      className,
      trackClassName,
      indicatorClassName,
      thumbClassName,
      value,
      defaultValue,
      ...props
    },
    ref,
  ): React.ReactElement => {
    const values = React.useMemo<readonly number[]>(() => {
      if (Array.isArray(value)) {
        return value;
      }

      if (typeof value === "number") {
        return [value];
      }

      if (Array.isArray(defaultValue)) {
        return defaultValue;
      }

      if (typeof defaultValue === "number") {
        return [defaultValue];
      }

      return [0];
    }, [defaultValue, value]);

    return (
      <SliderPrimitive.Root
        ref={ref}
        value={value}
        defaultValue={defaultValue}
        className={cn("relative flex h-10 w-full items-center", className)}
        {...props}
      >
        <SliderPrimitive.Control className="relative w-full">
          <SliderPrimitive.Track
            className={cn(
              "h-1.5 w-full rounded-full bg-border",
              trackClassName,
            )}
          >
            <SliderPrimitive.Indicator
              className={cn(
                "h-full rounded-full bg-primary",
                indicatorClassName,
              )}
            />
          </SliderPrimitive.Track>

          {values.map((item, index) => (
            <SliderPrimitive.Thumb
              key={`${item}-${index}`}
              index={index}
              className={cn(
                "block size-4 rounded-full border border-primary bg-primary cursor-pointer",
                thumbClassName,
              )}
            />
          ))}
        </SliderPrimitive.Control>
      </SliderPrimitive.Root>
    );
  },
);

Slider.displayName = "Slider";

export { Slider };
